import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useApi, errMsg } from "@/lib/api";

const MeCtx = createContext(null);

export function MeProvider({ children }) {
  const api = useApi();
  const [me, setMe] = useState(null);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/me");
      setMe(data);
      setError(null);
    } catch (e) {
      setError(errMsg(e));
    }
  }, [api]);

  useEffect(() => {
    reload();
  }, [reload]);

  return <MeCtx.Provider value={{ me, error, reload }}>{children}</MeCtx.Provider>;
}

export const useMe = () => useContext(MeCtx);
